<ng-container *ngSubscribe="data as data">
  <h2 mat-dialog-title>{{ data.title }}</h2>

  @if (data.notes) {
  <alert-bar>{{ data.notes }}</alert-bar>
  }

  <ng-container *ngSubscribe="form as form">
    <form [formGroup]="form" (submit)="submit()" class="standard">
      <mat-dialog-content cdkFocusInitial>
        <ng-template
          component-host
          [spec]="attachFormToFieldCmp(data.fieldsCmp, form)"
        ></ng-template>
      </mat-dialog-content>

      <mat-dialog-actions>
        <submit-control
          (cancel)="cancel()"
          [icon]="data.submitIcon || 'check2'"
        >
          {{ data.submitLabel || 'Save changes' }}
        </submit-control>
      </mat-dialog-actions>
    </form>
  </ng-container>
</ng-container>
